import { Component, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { AppService } from 'src/app/services/app-service.service';
import { environment } from 'src/environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FileOperationsService } from 'src/app/modules/admin/shared/services/file-operations.service';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
@Component({
  selector: 'app-book-viewer',
  templateUrl: './book-viewer.component.html',
  styleUrls: ['./book-viewer.component.scss']
})
export class BookViewerComponent {
  @ViewChildren('videoPlayer') videoPlayers: QueryList<ElementRef>;

  files: any = [];
  images: any = [];
  videos: any = [];
  urlVideoFiles: any = [];
  audios: any = [];
  currentFile: any = '';
  books: any = [];
  currentFileType = 'book';
  src = "";
  bookSrc = '';
  bookCover = '';
  chaptersList: any = [];
  allFilesList: any = [];
  siteUrl = environment.siteUrl;
  expandedCategories = {
    images: false,
    documents: false,
    videos: false,
    audios: false
  };
  selectedVideo: any = null;
  showVideoPopup = false;
  youtubeVideos: any[] = [];
  selectedYoutubeVideo: any = null;
  showYoutubePopup = false;
  videoUrls: any[] = [];

  constructor(
    private appService: AppService,
    private sanitizer: DomSanitizer,
    private fileOperationsService: FileOperationsService
  ) {

    this.appService.getBooks().subscribe((res: any) => {
      this.books = res;
      this.setBookInfo({ index: 0 });
      this.appService.getChapters().subscribe((res: any) => {
        this.chaptersList = res;
        // console.log(this.chaptersList);
        this.processMedia(this.books[0].id)
      })
    });

    // Example YouTube videos - replace with your actual data source
    // this.youtubeVideos = [
    //   {
    //     title: 'Sharani Ponguru',
    //     url: 'https://youtu.be/L19V9-bzdyE?si=GyvYxWFCOwSOqlWF',
    //     description: 'Welcome to workbook'
    //   },
    //   {
    //     title: 'Sharani Ponguru',
    //     url: 'https://youtu.be/ZY2b5PGRs5A?si=ErkmkEWk8ZMIIUB6',
    //     description: 'Welcome to workbook'
    //   },
    //   {
    //     title: 'Sharani Ponguru',
    //     url: 'https://youtu.be/sACFGUFjwZ8?si=7tQvM_vnYV3ve4Rz',
    //     description: 'Welcome to workbook'
    //   }
    // ];
  }

  getFileName(filepath: string): string {
    let filename = filepath.split('/').pop().split('.')[0];
    filename = filename.split('_').slice(1).join(' ');
    return filename;
  }

  setBookInfo(event: any) {
    let index = event.index + 1;
    this.src = this.appService.getPageByKey('book_' + index)?.title;
    this.bookSrc = this.appService.getPageByKey('book_' + index)?.title;
    this.bookCover = this.appService.getPageByKey('book_cover_' + index)?.title;
  }

  processMedia(book_id) {
    let arrayList: any = [];
    this.chaptersList.filter((item: any) => {
      return item.book_id == book_id;
    }).forEach((item: any) => {
      if (item.additionalInfo) {
        let infoArray = JSON.parse(item.additionalInfo || '[]')
        if (infoArray)
          infoArray.forEach((info: any) => {
            info.chapterName = item.name;
          });
        arrayList = arrayList.concat(infoArray);
        // console.log(arrayList);
      }
    });

    this.videos = arrayList.filter((item: any) => {
      return item.type == 'Video' && !item.value.toLowerCase().endsWith('.txt');
    });
    this.urlVideoFiles = arrayList.filter((item: any) => {
      return item.type == 'Video';// && item.value.toLowerCase().startsWith('http');
    });

    forkJoin(
      this.urlVideoFiles.map((item: { value: string, chapterName: string }) =>
        this.fileOperationsService.getVideoEmbedData(item.value).pipe(
          catchError(err => {
            console.error(`Error fetching URL for item ${item.value} (Chapter: ${item.chapterName}):`, err);
            return of(null);
          })
        )
      )
    )
      .subscribe({
        next: (resultsArray: (any | null)[]) => {
          this.videoUrls = resultsArray.map((result, index) => ({
            ...result,
            chapterName: this.urlVideoFiles[index].chapterName
          }));
        },
        error: (err: any) => {
          console.error('Unexpected error in forkJoin:', err);
        }
      });
    this.audios = arrayList.filter((item: any) => {
      return item.type == 'Audio';
    });
  }


  contentChange(file, type, index?) {
    // Stop any currently playing videos
    this.stopAllVideos();

    this.currentFile = file;
    this.currentFileType = type;

    if (type === 'video') {
      // Give the DOM time to render the video element
      setTimeout(() => {
        // Play the specific video by its ID
        const videoElement = document.getElementById('video-' + index) as HTMLVideoElement;
        if (videoElement) {
          videoElement.play().catch(error => {
            console.log('Autoplay prevented by browser:', error);
          });
        }
      }, 100);
    }
  }

  // Add this new method to stop all videos
  stopAllVideos() {
    const videoElements = document.querySelectorAll('video');
    videoElements.forEach(video => {
      video.pause();
      video.currentTime = 0;
    });
  }

  toggleFolder(event: Event) {
    const folderElement = event.currentTarget as HTMLElement;
    const folderContent = folderElement.nextElementSibling as HTMLElement;

    if (folderContent) {
      folderContent.classList.toggle('expanded');
      folderElement.classList.toggle('open');
    }
  }

  onImageLoad(event: Event) {
    const img = event.target as HTMLImageElement;
    // This ensures the container adjusts to the image's natural dimensions
    // while still respecting max-width constraints
    if (img.naturalWidth > window.innerWidth) {
      img.style.width = '100%';
    } else {
      img.style.width = 'auto';
    }
  }

  toggleCategory(category: string) {
    this.expandedCategories[category] = !this.expandedCategories[category];
  }

  playVideo(videoUrl: string, index: number): void {
    if (!this.showVideoPopup) {
      this.currentFile = videoUrl;

      setTimeout(() => {
        const videoElement = document.getElementById('video-' + index) as HTMLVideoElement;
        if (videoElement) {
          videoElement.muted = true;

          videoElement.play().catch(error => {
            console.log('Autoplay prevented by browser:', error);
          });
        }
      }, 100);
    }
  }

  openVideoPopup(video: any): void {
    this.stopAllVideos();
    this.selectedVideo = video;
    this.showVideoPopup = true;
  }

  closeVideoPopup(): void {
    this.showVideoPopup = false;
    this.selectedVideo = null;
  }

  // Audio player methods
  toggleAudio(audioElement: HTMLAudioElement) {
    const card = audioElement.closest('.minimal-audio-card') as HTMLElement;

    if (audioElement.paused) {
      // Pause all other audio elements first
      document.querySelectorAll('audio').forEach(audio => {
        if (audio !== audioElement && !audio.paused) {
          audio.pause();
          const otherCard = audio.closest('.minimal-audio-card') as HTMLElement;
          if (otherCard) otherCard.classList.remove('playing');
        }
      });

      audioElement.play();
      if (card) card.classList.add('playing');
    } else {
      audioElement.pause();
      if (card) card.classList.remove('playing');
    }
  }

  updateProgress(audioElement: HTMLAudioElement, progressBar: HTMLElement, currentTimeEl: HTMLElement, durationEl: HTMLElement) {
    const percent = (audioElement.currentTime / audioElement.duration) * 100;
    progressBar.style.width = `${percent}%`;
    currentTimeEl.textContent = this.formatTime(audioElement.currentTime);
    durationEl.textContent = this.formatTime(audioElement.duration);
  }

  formatTime(seconds: number): string {
    if (isNaN(seconds)) return '0:00';

    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  }

  seekAudio(event: MouseEvent, audioElement: HTMLAudioElement, progressBar: HTMLElement) {
    const progressTrack = event.currentTarget as HTMLElement;
    const clickPosition = (event.offsetX / progressTrack.offsetWidth);
    audioElement.currentTime = clickPosition * audioElement.duration;
  }

  onAudioLoaded(audioElement: HTMLAudioElement, durationEl: HTMLElement) {
    durationEl.textContent = this.formatTime(audioElement.duration);
  }

  changeVolume(event: Event, audioElement: HTMLAudioElement) {
    const input = event.target as HTMLInputElement;
    audioElement.volume = parseFloat(input.value);

    // Update volume icon based on level
    const volumeIcon = input.previousElementSibling as HTMLElement;
    if (audioElement.volume === 0) {
      volumeIcon.className = 'fas fa-volume-mute volume-icon';
    } else if (audioElement.volume < 0.5) {
      volumeIcon.className = 'fas fa-volume-down volume-icon';
    } else {
      volumeIcon.className = 'fas fa-volume-up volume-icon';
    }
  }

  toggleMute(audioElement: HTMLAudioElement) {
    audioElement.muted = !audioElement.muted;
    const volumeIcon = audioElement.parentElement?.querySelector('.volume-icon') as HTMLElement;

    if (audioElement.muted) {
      volumeIcon.className = 'fas fa-volume-mute volume-icon';
    } else {
      if (audioElement.volume < 0.5) {
        volumeIcon.className = 'fas fa-volume-down volume-icon';
      } else {
        volumeIcon.className = 'fas fa-volume-up volume-icon';
      }
    }
  }

  // Keep existing audio methods for backward compatibility
  playAudio(audioElement: HTMLAudioElement) {
    // Pause all other audio elements first
    document.querySelectorAll('audio').forEach(audio => {
      if (audio !== audioElement && !audio.paused) {
        audio.pause();
      }
    });
    audioElement.play();
  }

  stopAudio(audioElement: HTMLAudioElement) {
    audioElement.pause();
    audioElement.currentTime = 0;
  }

  isPlaying(audioElement: HTMLAudioElement): boolean {
    return !audioElement.paused;
  }

  ngAfterViewInit() {
    // Generate stars for space card background
    this.generateStars();
  }

  generateStars() {
    setTimeout(() => {
      const starsContainer = document.querySelector('.stars-bg');
      if (starsContainer) {
        // Clear any existing stars
        starsContainer.innerHTML = '';

        // Generate random stars
        const numberOfStars = 100;
        for (let i = 0; i < numberOfStars; i++) {
          const star = document.createElement('div');
          star.classList.add('star');

          // Random position
          const left = Math.random() * 100;
          const top = Math.random() * 100;

          // Random size
          const size = Math.random() * 3;

          // Random animation delay
          const delay = Math.random() * 5;

          // Apply styles
          star.style.left = `${left}%`;
          star.style.top = `${top}%`;
          star.style.width = `${size}px`;
          star.style.height = `${size}px`;
          star.style.animationDelay = `${delay}s`;

          starsContainer.appendChild(star);
        }
      }
    }, 100);
  }

  // YouTube related methods
  getYoutubeVideoId(url: string): string {
    // Extract video ID from YouTube URL
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : '';
  }

  getSafeYoutubeUrl(url: string): SafeResourceUrl {
    // Convert YouTube watch URL to embed URL and sanitize
    const videoId = this.getYoutubeVideoId(url);
    const embedUrl = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1';
    return this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
  }

  openYoutubePopup(video: any): void {
    this.selectedYoutubeVideo = video;
    this.showYoutubePopup = true;
  }

  closeYoutubePopup(): void {
    this.showYoutubePopup = false;
    this.selectedYoutubeVideo = null;
  }
}
